import React from 'react';
import { Link } from 'react-router-dom';
import { servicesData } from '../data/services';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ServicesPreview = () => {
  const { t } = useTranslation();
  // Show all service categories
  const previewServices = Object.entries(servicesData);

  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-green mb-4">{t('home.services.title')}</h2>
          <div className="w-24 h-1 bg-gold-primary mx-auto"></div>
          <p className="text-gray-600 mt-6 max-w-2xl mx-auto">
            {t('home.services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {previewServices.map(([key, section]) => (
            <div key={key} className="group relative bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-cream-off h-[480px]">
              {/* Image Background */}
              <div className="absolute inset-0 z-0">
                <img 
                  src={section.image} 
                  alt={section.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-green-deep via-dark-green/90 to-transparent opacity-90 group-hover:opacity-95 transition-opacity"></div>
              </div>

              {/* Content Overlay */}
              <div className="relative z-10 p-8 h-full flex flex-col">
                {/* Generated Icon Thumbnail */}
                <div className={`mb-6 w-16 h-16 rounded-2xl bg-gradient-to-br ${section.color} flex items-center justify-center shadow-lg transform group-hover:rotate-6 transition-all duration-500 border-2 border-white/20`}>
                  {React.cloneElement(section.icon, { size: 32, className: "text-white drop-shadow-md" })}
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-4 drop-shadow-md">{t(`services.categories.${key}.title`)}</h3>
                
                <ul className="space-y-3 mb-8 flex-grow">
                  {Object.entries(t(`services.categories.${key}.items`, { returnObjects: true })).slice(0, 4).map(([itemKey, item], i) => (
                    <li key={i} className="flex items-center text-white/90 text-sm font-medium">
                      <div className="w-1.5 h-1.5 bg-gold-primary rounded-full mr-3 shadow-[0_0_8px_rgba(212,175,55,1)]"></div>
                      {item.name}
                    </li>
                  ))}
                </ul>

                <Link 
                  to={`/services/${key}`} 
                  className="inline-flex items-center justify-between w-full bg-white/10 backdrop-blur-md border border-white/20 text-white px-6 py-4 rounded-xl font-bold hover:bg-gold-primary hover:border-gold-primary transition-all duration-300 shadow-xl group/btn"
                >
                  <span>{t('home.services.viewAll')}</span>
                  <ArrowRight size={18} className="transform group-hover/btn:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <Link 
            to="/services" 
            className="inline-flex items-center space-x-3 bg-dark-green text-white px-12 py-5 rounded-2xl font-bold hover:bg-dark-green-deep hover:-translate-y-1 transition-all shadow-[0_10px_30px_rgba(1,50,32,0.3)]"
          >
            <span>{t('home.services.exploreAll')}</span>
            <ArrowRight size={22} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
